module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"service.field.customer_name.placeholder":"ชื่อลูกค้า","service.field.customer_phone.placeholder":"เบอร์ติดต่อ","service.field.customer_province.placeholder":"ระบุจังหวัด"}}')
  delete Component.options._Ctor
}
